import { COLORS } from "shared/consts";
import styled from "styled-components";

export const DictionaryEditPopup = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DictionaryEditHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  h3 {
    color: ${COLORS.FG.DEFAULT};

    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  svg {
    cursor: pointer;
  }
`;

export const DictionaryEditContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .input--textarea .input__label {
    font-size: 12px;
  }
`;

export const DictionaryEditFooter = styled.div<{ isMobile: boolean }>`
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 16px;
  margin-top: 30px;
  ${({ isMobile }) =>
    isMobile &&
    `
    flex-direction: column
    `}
`;
